import styled from "styled-components";

export const Card = styled.div`
  border-radius: ${({ theme }) => theme.radii.card}px;
  background: ${({ $glass }) => ($glass ? "rgba(255,255,255,0.10)" : "white")};
  backdrop-filter: ${({ $glass }) => ($glass ? "blur(16px)" : "none")};
  border: 1px solid
    ${({ theme, $glass }) => ($glass ? theme.colors.glass.border : theme.colors.border)};
  box-shadow: ${({ theme, $glass }) => ($glass ? theme.shadows.glass : theme.shadows.soft)};
`;

export const CardHeader = styled.div`
  padding: 20px 24px 12px;
`;

export const CardTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.heading};
`;

export const CardDescription = styled.p`
  margin: 6px 0 0;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text.body};
`;

export const CardContent = styled.div`
  padding: 0 24px 16px;
`;

export const CardFooter = styled.div`
  padding: 0 24px 20px;
  display: flex;
  align-items: center;
`;


